import { useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import Box from '@mui/material/Box';

export default function AdSenseBanner() {
  const pushed = useRef(false);

  useEffect(() => {
    if (Capacitor.isNativePlatform() || pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {}
  }, []);

  if (Capacitor.isNativePlatform()) return null;

  return (
    <Box sx={{ width: '100%', my: 1 }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-3994844429643035"
        data-ad-slot="2246157448"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </Box>
  );
}
